import { Injectable } from '@angular/core';
import { VenueDetails } from './venue-details.model';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UserService } from 'app/Shared/Services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { map } from 'rxjs';
import { UrlsService } from 'app/Shared/Services/urls.service';

@Injectable({
  providedIn: 'root'
})
export class VenueDetailsService {
    isEdit: boolean = false;
    isView: boolean = false;
    isAdd: boolean = false;
    editRow!: VenueDetails | any;
    addRow: VenueDetails|any = new VenueDetails();
    selectedRow!: VenueDetails | any;
    venueTypeOptions = [
            { "label": "PRV", "value": "PRV", "description": "PRV" },
            { "label": "EV/SRV", "value": "EV/SRV", "description": "EV/SRV" }]
    reportingQuarterOptions = [
            { "label": "1", "value": "1", "description": "1st quarter" },
            { "label": "2", "value": "2", "description": "2nd quarter" },
            { "label": "3", "value": "3", "description": "3rd quarter" },
            { "label": "4", "value": "4", "description": "4th quarter" },]

    defaultFilterArray: any = [];
    isLoadingResults = true;
    rowcount!: number;
    totalRecords: any = 0;
    startLimit: number = 0;
    endLimit: number = 0;
    defaultData: any;
    dataset: any[] = [];

    
  constructor(private sharedHttpClientService: SharedHttpClientService,
        private userService: UserService,
        private gridService: GridService,
        private readonly urlsService: UrlsService) { 
        
  }

  defaultFilter() {
    this.defaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Venue MPID', 'columnname': 'venueMPID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Venue Name', 'columnname': 'venueName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
    ];
  }

  getDefaultFilters(){
    return this.defaultFilterArray;
  }

  reloadData(){
      let payload = {
        "mpid": this.userService.getActiveMPID(),
        "data": this.defaultFilterArray,
        "startLimit": this.startLimit,
        "endLimit": this.rowcount
    }
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_List), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (data: any) => {
                this.isLoadingResults = false;
                let response: any = data;
                this.dataset = response.Data;
                this.defaultData = this.dataset;
                this.totalRecords = response.totalCount;
                this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
              },        
              error: (err: HttpErrorResponse) => {
                this.isLoadingResults = false;
              }
        });  
  }


  getData(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_List), payload);
  }
  getAdd(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_Add), payload);
  }
  getEdit(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_Edit), payload);
  }
  getDelete(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_Delete), payload);
  }
  getApprove(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_VenueDetails_Approve), payload);
  }

}
